// search_card_controller.js
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    const headingElements = document.querySelectorAll('.collapsible-heading');
    const firstTab = headingElements[0].parentElement;

    for (let i = 1; i < headingElements.length; i++) {
      const heading = headingElements[i];
      if (heading.nextElementSibling.id !== 'company_logo_content') {
        heading.classList.remove('active-heading');
        heading.nextElementSibling.classList.remove('show');
      }
    }

    document.querySelectorAll('.collapsible-heading').forEach((heading) => {
      heading.addEventListener('click', function () {
        heading.classList.toggle('active-heading');
        heading.nextElementSibling.classList.toggle('show');
        heading.getElementsByTagName('img')[0].classList.toggle('open');
      });
    });

    // Get the parent element (this.element)
    const parentElement = this.element;

    // Find the first element with the class 'form-input__box--errors' within the parent element
    const errorElements = parentElement.querySelectorAll('.form-input__box--errors');

    if (errorElements.length !== 0) {
      firstTab.querySelector('.collapsible-heading').classList.remove('active-heading');
      firstTab.querySelector('.collapsible-content').classList.toggle('show');
      firstTab.getElementsByTagName('img')[0].classList.toggle('open');
    }
    for (let i = 0; i < errorElements.length; i++) {
      const errorElement = errorElements[i];
      // Check if the error element was found
      if (errorElement) {
        // Get the closest ancestor with the class 'collapsible-tab'
        const collapsibleTabElement = errorElement.closest('.collapsible-tab');

        if (collapsibleTabElement) {
          // Target the element with class 'collapsible-heading' and add 'has-text-danger'
          const headingElement = collapsibleTabElement.querySelector('.collapsible-heading');
          if (headingElement) {
            headingElement.classList.add('has-text-danger');
            headingElement.classList.add('active-heading');
            headingElement.getElementsByTagName('img')[0].classList.toggle('open');
            headingElement.getElementsByTagName('img')[0].classList.add('edit_profile_arrow_error');
          }

          // Target the element with class 'collapsible-content' and add 'show'
          const contentElement = collapsibleTabElement.querySelector('.collapsible-content');
          if (contentElement) {
            contentElement.classList.add('show');
          }
        }
      }
    }
  }
}
